import React from "react";
import styled from "styled-components";
import { Container } from "@mui/material";
import { settings } from "../data/settings";
import SEO from "../components/SEO";

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const SubTitle = styled.h2`
  font-size: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const PageMentionsLegales = () => {
  return (
    <Container
      sx={{ py: 4 }}
      style={{ maxWidth: "800px", marginTop: settings.navbar.height }}
    >
      {" "}
      <SEO
        title="Mentions legales et confidentialite | DigiBuddy"
        description="Mentions legales, politique de confidentialite, cookies et conditions d'utilisation du site DigiBuddy."
        url="https://www.digibuddy.fr/mentions-legales"
        canonical="https://www.digibuddy.fr/mentions-legales"
      />
      <Title>Mentions légales</Title>
      <Paragraph>
        <strong>Nom du site :</strong> {settings.websiteName}
        <br />
        <strong>Propriétaire :</strong> {settings.compagnieName}
        <br />
        <strong>Responsable de publication :</strong> Vincent Deliencourt |
        Digibuddy
        <br />
        <strong>Conception et développement :</strong> Vincent Deliencourt |
        Digibuddy
        <br />
        <strong>Crédits photos :</strong> Digibuddy
        <br />
        <strong>Hébergeur :</strong> o2switch - 222 Boulevard Gustave Flaubert,
        63000 Clermont-Ferrand, France
        <br />
        <strong>Contact :</strong> contact@digibuddy.fr
      </Paragraph>
      <SubTitle>Politique de confidentialité</SubTitle>
      <Paragraph>
        Le site collecte des données personnelles uniquement dans le but de vous
        fournir les meilleurs services possibles (formulaire de contact, demande
        de devis, etc.). Ces données incluent, entre autres, votre nom, adresse
        email, téléphone, ou toute autre donnée transmise volontairement.
      </Paragraph>
      <Paragraph>
        Nous nous engageons à ne jamais vendre ou louer vos données. Elles sont
        conservées pour une durée maximale de 3 ans (marketing) et 6 ans
        (facturation). Vous avez un droit d'accès, de rectification et de
        suppression de vos données à tout moment en nous contactant.
      </Paragraph>
      <Paragraph>
        Le site utilise un certificat SSL (HTTPS), des sauvegardes régulières et
        un hébergement sécurisé chez o2switch pour garantir la protection de vos
        données.
      </Paragraph>
      <SubTitle>Cookies</SubTitle>
      <Paragraph>
        Le site utilise des cookies à des fins de mesure d’audience et pour
        améliorer l’expérience utilisateur. Vous pouvez les refuser via votre
        navigateur ou les accepter via notre bandeau de consentement.
      </Paragraph>
      <SubTitle>Conditions d'utilisation</SubTitle>
      <Paragraph>
        L’utilisation du site implique l’acceptation pleine et entière des
        conditions générales d’utilisation décrites ici. Ces conditions peuvent
        être modifiées à tout moment, les utilisateurs sont donc invités à les
        consulter régulièrement.
      </Paragraph>
    </Container>
  );
};

export default PageMentionsLegales;
